/**
 * CVC event text (label_long) must end with an ASCII period in all languages.
 * Idempotent if the string already ends with ".".
 */
export function ensureCvcLabelLongEndsWithDot(text: string): string {
  const t = (text ?? "").trimEnd();
  if (t === "") return "";
  return t.endsWith(".") ? t : `${t}.`;
}
